import styled from 'styled-components'

// Components
import Pill, { PillProps } from 'components/Pill'
import Button, { ButtonUnstyled } from 'components/Button'

import Panel from '../Panel'
import RowGroup from '../RowGroup'

import { breakpoint } from 'utils'

export const CanceledPill = styled(Pill).attrs<PillProps>({
  color: 'red',
  variant: { kind: 'primary' },
})`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`

export const BlockText = styled.span`
  display: block;
`

export const HeaderButton = styled(Button)`
  transition: none;
`

export const StyledPanelTitle = styled(Panel.Title)`
  display: flex;

  ${breakpoint('base', 'xs')`
    flex-direction: column;
    align-items: flex-start;
  `}

  /* Hack to fix the Button presentation in IE11 */
  & ${ButtonUnstyled} {
    flex-shrink: 0;
    display: inline;
  }
`

export const Row = styled(RowGroup.Row)`
  ${breakpoint('base', 'sm')`
    display:flex;
    flex-direction: column;
  `}
`

export const ContentCell = styled(RowGroup.CaptionCell)`
  ${breakpoint('base', 'sm')`
    margin: 0;
    width: 100%;
  `}
`
